import { readableDateTimeFormat } from '../../utils/dateUtils'
import { Status } from '../AB Membership/constants'
import { unpaid } from '../OPDScreen/constant'
import { noData } from '../Radiology/Constants/constants'
import { invoiced, canceled, Cancelled, paid } from './models'
import {
  MEMBERSHIP_STATUS_LABELS,
  MEMBERSHIP_ACTIVITY_STATUS,
  DEFAULT_VALUES,
  MIME_TYPES,
  FILE_EXTENSION,
} from './constants'

export const secondaryMembershipStatuses = (partnerIds: any) => {
  if (!Array?.isArray(partnerIds) || partnerIds?.length === 0) {
    return DEFAULT_VALUES?.NO_DATA
  }
  return partnerIds
    ?.map((p: any) => p?.ref)
    ?.filter(Boolean)
    ?.join(', ')
}
export const statusFunction = (id: string) => {
  switch (id) {
    case 'paid':
      return MEMBERSHIP_STATUS_LABELS?.PAID_MEMBER
    case 'none':
      return MEMBERSHIP_STATUS_LABELS?.NON_MEMBER
    case 'waiting':
      return MEMBERSHIP_STATUS_LABELS?.WAITING_MEMBER
    case 'invoiced':
      return MEMBERSHIP_STATUS_LABELS?.INVOICED_MEMBER
    case 'canceled':
      return MEMBERSHIP_STATUS_LABELS?.CANCELLED_MEMBER
    case 'old':
      return MEMBERSHIP_STATUS_LABELS?.OLD_MEMBER
    default:
      return MEMBERSHIP_STATUS_LABELS?.OTHERS
  }
}
export const dateCheck = (date: string) => {
  const d1 = new Date(date)
  const d2 = new Date()
  if (d1 >= d2) {
    return MEMBERSHIP_ACTIVITY_STATUS?.ACTIVE
  } else {
    return MEMBERSHIP_ACTIVITY_STATUS?.EXPIRED
  }
}
export const getStatusLabel = (state: any) => {
  const statusMap: any = {
    invoiced: unpaid,
    waiting: unpaid,
    paid: paid,
    old: paid,
  }
  return statusMap?.[state] || DEFAULT_VALUES?.NO_DATA
}
export const refactoredData = (dataArray: any[]) => {
  return dataArray?.map((item: any) => ({
    id: item?.id,
    membershipId: item?.name || null,
    Uhid: item?.partner?.ref || null,
    primary: item?.partner?.name || null,
    mobile: item?.partner?.phone || null,
    operatingUnit:
      item?.account_invoice_id?.operating_unit_id?.[1]?.split(' ')?.[1] || null,
    secondary: secondaryMembershipStatuses(item?.partner_ids) || null,
    age: item?.partner_age || null,
    gender: item?.partner_gender || null,
    membershipName: item?.membership_id?.[1] || null,
    membershipType: statusFunction(item?.state),
    validity: item?.date_to,
    membershipStatus:
      item?.state === Status?.waiting || item?.state === invoiced
        ? Status?.waiting
        : item?.state === canceled
        ? Cancelled
        : item?.date_to
        ? dateCheck(item?.date_to)
        : noData,
    invoiceId: item?.account_invoice_id?.id || null,
    paymentStatus: getStatusLabel(item?.state),
    createdOn:
      readableDateTimeFormat(
        new Date(item?.account_invoice_id?.invoice_date_time ?? '')
      ) || null,
    createdBy: item?.account_invoice_id?.thop_user_name || null,
    updatedOn: item?.write_date ?? null,
    updatedBy: item?.thop_last_updated_user_name ?? null,
    date_From: item?.date_from || null,
    date_to: item?.date_to || null,
    type: item?.membership_id?.[1] || null,
  }))
}
export const stringToTitleCase = (str: string) => {
  if (!str) return ''

  return str
    .toLowerCase()
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const viewBase64File = (base64String: string) => {
  if (!base64String) return

  let mimeType: string = MIME_TYPES?.PDF
  if (base64String.startsWith('data:')) {
    mimeType = base64String.substring(5, base64String.indexOf(';'))
  } else if (base64String.startsWith('/')) {
    mimeType = MIME_TYPES?.JPEG
  } else if (base64String.startsWith('i')) {
    mimeType = MIME_TYPES?.PNG
  }
  const cleanBase64 = base64String.replace(/^data:.*;base64,/, '')
  const byteCharacters = atob(cleanBase64)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: mimeType })
  const blobUrl = URL.createObjectURL(blob)

  window.open(blobUrl, '_blank')
}
export const downloadBase64File = (base64String: string, fileName: any) => {
  if (!base64String) return

  const mimeMatch = base64String.match(/^data:(.*?);base64,/)
  const mimeType = mimeMatch ? mimeMatch[1] : MIME_TYPES?.OCTET_STREAM

  const extension = mimeType.split('/')[1] || FILE_EXTENSION?.DEFAULT
  const cleanBase64 = base64String.replace(/^data:.*;base64,/, '')

  const byteCharacters = atob(cleanBase64)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: mimeType })

  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = blobUrl
  link.download = `${fileName}.${extension}`

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => URL.revokeObjectURL(blobUrl), 5000)
}
